function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.39.569h0c-.372-.17-.811-.104-1.116.168l-1.447 1.266-1.97-1.74c-.395-.35-.994-.35-1.39 0L8.5 2 6.532.263c-.396-.35-.995-.35-1.39 0l-1.97 1.74L1.723.737C1.296.36.642.399.262.822c-.17.189-.264.433-.262.686v18.984c-.003.565.458 1.027 1.03 1.03.257.002.505-.09.696-.259l1.447-1.266 1.97 1.74c.395.35.994.35 1.39 0L8.5 20l1.968 1.738c.395.35.994.35 1.39 0l1.97-1.74 1.448 1.266c.428.376 1.082.338 1.462-.085.17-.189.264-.433.262-.687V1.508c.005-.405-.235-.774-.61-.939zm-1.874 18.657c-.395-.347-.99-.345-1.384.003l-1.97 1.74-1.967-1.738c-.396-.35-.995-.35-1.39 0l-1.968 1.738-1.97-1.74c-.392-.348-.986-.35-1.38-.004l-1.444 1.266v-2.746L1.038 1.51l1.445 1.265c.396.346.992.345 1.385-.003l1.97-1.74 1.967 1.738c.396.35.994.35 1.39 0l1.968-1.738 1.97 1.74c.392.348.986.35 1.38.003l1.444-1.266v13.05l.005 5.933-1.446-1.265z",
  transform: "translate(3 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.475 10h-9.95c-.29 0-.525.224-.525.5s.235.5.525.5h9.95c.29 0 .525-.224.525-.5s-.235-.5-.525-.5zM8.498 7H3.502C3.225 7 3 7.224 3 7.5s.225.5.502.5h4.996C8.775 8 9 7.776 9 7.5S8.775 7 8.498 7zM13.475 13h-9.95c-.29 0-.525.224-.525.5s.235.5.525.5h9.95c.29 0 .525-.224.525-.5s-.235-.5-.525-.5z",
  transform: "translate(3 1)"
}));

var SvgTicketBorderLight = function SvgTicketBorderLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTicketBorderLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ticket-border-light.3670240b.svg";
export { ForwardRef as ReactComponent };